enum PublicDocumentType {
  PRIVACY_POLICY = 'privacyPolicy',
}

type PublicDocument = {
  type: PublicDocumentType;
  version: number;
};

export { PublicDocumentType, type PublicDocument };
